<template>
    <div class="user-details">
        <bread-crumb :bread-list="breadList" />
        <div class="details-content"
             v-loading="loading">
            <div class="base-info-warp">
                <div class="info-warp">
                    <div class="left-warp">
                        <el-divider direction="vertical"></el-divider>
                        <span class="info-text">基本信息</span>
                    </div>
                    <div class="right-warp"
                         @click="handleEdit"
                         v-if="!editShow">
                        <i class="iconfont icon-edit1"></i>
                        <span class="edit-text">编辑</span>
                    </div>
                    <div v-else>
                        <el-button class="cancle-btn"
                                   @click="editShow=!editShow">取消</el-button>
                        <el-button class="confirm-btn"
                                   @click="handleUserUpdate">确认</el-button>
                    </div>
                </div>
                <div class="info-content">
                    <div class="head-warp"
                         style="width: 290px;">
                        <label class="info-label">头像：</label>
                        <div>
                            <div v-if="!editShow">
                                <img :src="'/ms-hoc-video/v1/image/download?fileName='+ appUserBaseDO.headSculpture"
                                     class="head-img"
                                     v-if="appUserBaseDO.headSculpture" />
                                <span v-else
                                      style="color:#333;font-size:14px;position: relative;top: -3px;left: 20px;">暂无</span>
                            </div>

                            <div v-else>
                                <div v-if="appUserBaseDO.headSculpture"
                                     class="cover-content">
                                    <el-image fit="fill"
                                              class="cover-picture"
                                              :src="'/ms-hoc-video/v1/image/download?fileName='+ appUserBaseDO.headSculpture">
                                    </el-image>
                                    <i class="iconfont icon-jinggaochacha"
                                       @click="handleRemove"></i>
                                </div>
                                <el-upload v-loading="pictureLoading"
                                           v-else
                                           class="picture-uploader"
                                           :action="uploadAction"
                                           :show-file-list="false"
                                           accept=".jpg, .png"
                                           :on-success="handleSuccess"
                                           :before-upload="beforeUpload">
                                    <div class="picture-content">
                                        <i class="iconfont icon-camera"></i>
                                        <div class="picture_text">
                                            编辑
                                        </div>
                                    </div>
                                </el-upload>
                            </div>
                        </div>
                    </div>
                    <div style="margin-left:142px;width: 290px;">
                        <div>
                            <label class="info-label">姓名：</label>
                            <span class="info-text"
                                  v-if="!editShow">{{ appUserBaseDO.nickName }}</span>
                            <el-input placeholder="请输入姓名"
                                      class="info-input"
                                      v-model="appUserBaseDO.nickName"
                                      maxlength="15"
                                      v-else>
                            </el-input>
                        </div>
                        <div style="margin-top:20px;width: 290px;">
                            <label class="info-label">登录手机：</label>
                            <span class="info-text"
                                  v-if="!editShow">{{ appUserBaseDO.userName }}</span>
                            <el-input placeholder="请输入登录手机"
                                      class="info-input"
                                      v-model="appUserBaseDO.userName"
                                      maxlength="20"
                                      v-else>
                            </el-input>
                        </div>
                    </div>
                    <div style="margin-left:142px;width: 290px;">
                        <!-- <div>
                            <label class="info-label">ID：</label>
                            <span class="info-text">00001</span>
                        </div> -->
                        <div>
                            <label class="info-label">身份证：</label>
                            <span class="info-text"
                                  v-if="!editShow">{{ appUserBaseDO.cardNo }}</span>
                            <el-input placeholder="请输入身份证"
                                      class="info-input"
                                      v-model="appUserBaseDO.cardNo"
                                      maxlength="20"
                                      v-else>
                            </el-input>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="contactDOS.length > 0">
                <div class="patient-info"
                     v-for="(item, index) in contactDOS"
                     :key="index">
                    <div class="info-warp">
                        <div class="left-warp">
                            <el-divider direction="vertical"></el-divider>
                            <span class="info-text">就诊人信息</span>
                        </div>
                        <div class="right-warp"
                             @click="handleDelUser(item.contactId)">
                            <i class="el-icon-delete"></i>
                            <span class="delete-text">删除</span>
                        </div>
                    </div>
                    <div class="info-content">
                        <div style="width: 332px;">
                            <div>
                                <label class="info-label">姓名：</label>
                                <span class="info-text">{{ item.name }}</span>
                            </div>
                            <div style="margin-top:20px;">
                                <label class="info-label">证件类型：</label>
                                <span class="info-text"
                                      v-if="item.cardType === 'IDENTITY_CARD'">身份证</span>
                                <span class="info-text"
                                      v-else-if="item.cardType === 'OTHER'">其他</span>
                                <span class="info-text"
                                      v-else-if="item.cardType === 'HUKOU_NUMBER'">居民户口本</span>
                                <span class="info-text"
                                      v-else-if="item.cardType === 'MO_HK_NUMBER'">港澳居民来往内地通行证</span>
                                <span class="info-text"
                                      v-else-if="item.cardType === 'TW_NUMBER'">台湾居民来往大陆通行证</span>
                                <span class="info-text"
                                      v-if="item.cardType === 'PASSPORT_NUMBER'">护照</span>
                                <span class="info-text"
                                      v-else-if="item.cardType === 'FOREIGNER_NUMBER'">外国人居留证</span>
                            </div>

                        </div>
                        <div style="margin-left:102px;width: 290px;">
                            <div>
                                <label class="info-label">电话：</label>
                                <span class="info-text">{{ item.phone }}</span>
                            </div>
                            <div style="margin-top:20px;">
                                <label class="info-label">证件号码:</label>
                                <span class="info-text">{{ item.cardNo }}</span>
                            </div>

                        </div>
                        <div style="margin-left:142px;width: 290px;">
                            <div>
                                <label class="info-label">年龄：</label>
                                <span class="info-text">
                                    {{ item.birthday | getAge }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { checkCard } from '@/utils/IDCard'
import { getAppUserByIuid, postAppUserUpdate, postDelAppUser } from '@/api/patient/user'
export default {
    name: 'userDetails',
    data () {
        return {
            breadList: [{ label: '用户管理' }, { label: '用户列表', path: '/patient/user/userList' }, { label: '用户详情' }],
            editShow: false,
            loading: false,
            pictureLoading: false,
            appUserBaseDO: {},
            contactDOS: [],
            iuid: this.$route.query.iuid,
            type: this.$route.query.type

        }
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ]),
        uploadAction () {
            return `/ms-hoc-video/v1/image/upload?hospitalId=${this.userInfo.hospitalId}&iuid=${this.userInfo.iuid}&ImageType=PATIENTUSER`
        }
    },
    filters: {
        getAge (birthday) {
            let age = -1
            let today = new Date()
            let todayYear = today.getFullYear()
            let todayMonth = today.getMonth() + 1
            let todayDay = today.getDate()

            let stringDay = ''
            // eslint-disable-next-line no-useless-escape
            if (birthday.match(/^\d{4}[\-\/\s+]\d{1,2}[\-\/\s+]\d{1,2}$/)) {
                // eslint-disable-next-line no-useless-escape
                stringDay = new Date(birthday.replace(/[\-\/\s+]/i, '/'))
            } else if (birthday.match(/^\d{8}$/)) {
                stringDay = new Date(birthday.substring(0, 4) + '/' + birthday.substring(4, 6) + '/' + birthday.substring(6))
            }
            if (stringDay !== '') {
                let birthdayYear = stringDay.getFullYear()
                let birthdayMonth = stringDay.getMonth()
                let birthdayDay = stringDay.getDate()
                if (todayYear - birthdayYear < 0) {
                    console.log('出生日期选择错误!')
                } else {
                    if (todayMonth * 1 - birthdayMonth * 1 < 0) {
                        age = (todayYear * 1 - birthdayYear * 1) - 1
                    } else {
                        if (todayDay - birthdayDay >= 0) {
                            age = (todayYear * 1 - birthdayYear * 1)
                        } else {
                            age = (todayYear * 1 - birthdayYear * 1) - 1
                        }
                    }
                }
                return age * 1
            } else {
                return '无'
            }
        }
    },
    methods: {
        // 编辑用户详情
        handleEdit () {
            this.editShow = true
        },
        // 删除头像
        handleRemove () {
            this.appUserBaseDO.headSculpture = ''
            this.pictureLoading = false
        },
        async handleUserUpdate () {
            const phoneTest = /^[1][3,4,5,7,8,9][0-9]{9}$/
            if (!phoneTest.test(this.appUserBaseDO.userName)) {
                this.$message({
                    message: '您输入的登录手机号码格式不正确',
                    customClass: 'hos-message--warning',
                    iconClass: 'el-icon-warning',
                    duration: '2000'
                })
                return
            }
            if (!checkCard(this.appUserBaseDO.cardNo)) {
                this.$message({
                    message: '您输入的身份证号码格式不正确',
                    customClass: 'hos-message--warning',
                    iconClass: 'el-icon-warning',
                    duration: '2000'
                })
                return
            }
            let param = {
                iuid: this.iuid,
                headSculpture: this.appUserBaseDO.headSculpture,
                nickName: this.appUserBaseDO.nickName,
                userName: this.appUserBaseDO.userName,
                cardNo: this.appUserBaseDO.cardNo,
                hospitalId: this.userInfo.hospitalId
            }
            const { results } = await postAppUserUpdate(param)
            if (results) {
                this.$message({
                    message: '修改个人信息成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                })
                this.queryUserInfo()
                this.editShow = false
            } else {
                this.$message.error('修改个人信息失败，请联系管理员！')
            }
        },
        // 上传头像之前
        beforeUpload (file) {
            this.pictureLoading = true
            const isType = ['jpg', 'png']
            const fileName = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase() // 文件扩展名
            const isLt2M = file.size / 1024 / 1024 < 5

            if (!isLt2M) {
                this.$message.error('请上传2M以内的图片!')
                this.pictureLoading = false
                return false
            } else if (!isType.includes(fileName)) {
                this.$message.error('请上传' + isType.join(',') + '的文件!')
                this.pictureLoading = false
                return false
            } else {
                return true
            }
        },
        // 上传头像成功
        handleSuccess (res, file) {
            const data = res.results
            if (data && data.length > 0) {
                this.appUserBaseDO.headSculpture = data[0].originPictureId
            } else {
                this.$message.error('上传出错，请检查上传头像！')
            }

            this.pictureLoading = false
        },
        // 删除就诊人
        async handleDelUser (contactId) {
            this.loading = true
            const { results } = await postDelAppUser(contactId)
            if (results) {
                this.$message({
                    message: '删除就诊人信息成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.queryUserInfo()
            } else {
                this.$message.error('删除就诊人信息失败，请联系管理员！')
                this.loading = false
            }
        },
        // 查看用户信息和就诊人
        async queryUserInfo () {
            this.loading = true
            const { results } = await getAppUserByIuid(this.iuid)
            this.appUserBaseDO = results.appUserBaseDO
            this.contactDOS = results.contactDOS
            this.loading = false
        }
    },
    mounted () {
        if (this.type === 'edit') {
            this.editShow = true
        }
        if (this.type === 'view') {
            this.editShow = false
        }
        this.queryUserInfo()
    }
}
</script>

<style lang="scss">
.user-details {
    height: 100%;
    .details-content {
        min-height: calc(100% - 95px);
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        .info-warp {
            display: flex;
            justify-content: space-between;
            .left-warp {
                display: flex;
                align-items: center;
                .el-divider--vertical {
                    width: 4px;
                    background: #06aea6;
                    margin: 0;
                }
                .info-text {
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #333333;
                    text-align: left;
                    line-height: 14px;
                    margin-left: 10px;
                }
            }
            .cancle-btn {
                width: 51px;
                height: 22px;
                background: #cccccc;
                padding: 0;
                color: #fff;
                border-radius: 0;
                font-family: PingFangSC-Medium;
                font-size: 12px;
                border: none;
            }
            .confirm-btn {
                width: 51px;
                height: 22px;
                background: #3ac9a8;
                padding: 0;
                color: #fff;
                border-radius: 0;
                font-family: PingFangSC-Medium;
                font-size: 12px;
                border: none;
            }
            .right-warp {
                display: flex;
                align-items: center;
                cursor: pointer;
                .icon-edit1 {
                    color: #2e83d7;
                    font-size: 16px;
                }
                .edit-text {
                    font-family: PingFangSC-Medium;
                    font-size: 12px;
                    color: #198eeb;
                    letter-spacing: 0;
                    line-height: 12px;
                    margin-left: 6px;
                }
                .el-icon-delete {
                    color: #ee777b;
                    font-size: 16px;
                }
                .delete-text {
                    font-family: PingFangSC-Medium;
                    font-size: 12px;
                    color: #ee777b;
                    letter-spacing: 0;
                    line-height: 12px;
                    margin-left: 6px;
                }
            }
        }
        .info-content {
            display: flex;
            padding: 20px 0;
            border-bottom: 1px solid #ccc;
            .head-warp {
                display: flex;
                align-items: flex-start;
                .head-img {
                    margin-left: 20px;
                    width: 60px;
                    height: 60px;
                }
                .cover-content {
                    position: relative;
                    padding-left: 20px;
                    .cover-picture {
                        width: 60px;
                        height: 60px;
                    }
                    .icon-jinggaochacha {
                        cursor: pointer;
                        font-size: 16px;
                        color: #ec6a69;
                        position: absolute;
                        top: -10px;
                        left: 70px;
                    }
                }
            }
            .info-input {
                width: 210px;
                .el-input__inner {
                    border-radius: 3px;
                    border: 1px solid #dcdcdc;
                    height: 32px;
                }
            }
            .info-label {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                text-align: right;
                line-height: 14px;
                display: inline-block;
                width: 80px;
            }
            .info-text {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #333333;
                letter-spacing: 0;
                text-align: left;
                line-height: 14px;
                margin-left: 20px;
            }
            .picture-uploader {
                margin-left: 20px;
                width: 60px;
                height: 60px;
                opacity: 0.4;
                background: #5e5e5e;
                text-align: center;
                .picture-content {
                    margin-top: 9px;
                    .icon-camera {
                        font-size: 22px;
                        color: #fff;
                    }
                    .picture_text {
                        margin-top: 6px;
                        font-family: PingFangSC-Medium;
                        font-size: 14px;
                        color: #ffffff;
                        letter-spacing: 0;
                        line-height: 14px;
                    }
                }
            }
        }
        .patient-info {
            margin-top: 20px;
        }
    }
}
</style>
